import React, { useState, useEffect } from 'react';
import { Camera, Plus, X, Check, MapPin, Users, Percent, Link, FileText, Calendar, Settings, Sun, Moon, Clock } from 'lucide-react';
import { v4 as randomUUID } from 'uuid';
import { supabaseFreeTable } from '../../utils/supabase/clientFreeTable';
import './EditScreen.css';
import { useRestaurant, useUpdateRestaurant, useDeleteRestaurantImageFromBucket, useDeleteMainImageDatabase } from '../../api/restaurant';
import { useAuth } from '../../api/AuthProvider';
import { IoColorPaletteOutline } from "react-icons/io5";


const useLanguage = () => ({ language: 'MK' });

export default function EditScreen() {
  const { data: restaurant, isLoading, error } = useRestaurant();
  const { profile } = useAuth();
  const { language } = useLanguage();
  const isMKD = language === 'MK';
  const { mutate: updateDatabase } = useUpdateRestaurant();
  const { mutate: deleteImageFromBucket } = useDeleteRestaurantImageFromBucket();
  const { mutate: deleteMainImageDatabase } = useDeleteMainImageDatabase();
  const [images, setImages] = useState(restaurant?.images || []);
  const [previewImages, setPreviewImages] = useState([]);
  const [pendingImages, setPendingImages] = useState([]);
  const [pendingMainImage, setPendingMainImage] = useState(null);
  const [mainImage, setMainImage] = useState(restaurant?.mainImage || '');
  const [mainImagePreview, setMainImagePreview] = useState('');
  const [discount, setDiscount] = useState(restaurant?.discount || 0);
  const [title, setTitle] = useState(restaurant?.name || '');
  const [location, setLocation] = useState(restaurant?.location || '');
  const [details, setDetails] = useState(restaurant?.details || '');
  const [link, setLink] = useState(restaurant?.mapslink || '');
  const [contactInfo, setcontactInfo] = useState(restaurant?.contactInfo || '');
  const [maxGuests, setMaxGuests] = useState(restaurant?.maximumGuests || 0);
  const [lokacii, setLokacii] = useState(restaurant?.lokacii || []);
  const [sedenje, setSedenje] = useState('');
  const [planSections, setPlanSections] = useState(restaurant?.planSections || []);
  const [newPlanSection, setNewPlanSection] = useState('');
  const [menu, setMenu] = useState(restaurant?.menuUrl || '');
  const [errors, setErrors] = useState('');
  const [loading, setLoading] = useState(false);
  const [category2, setCategory2] = useState(restaurant?.category2 || '');
  const [reservationFrom, setReservationFrom] = useState(restaurant?.reservationFrom || 0);
  const [reservationTo, setReservationTo] = useState(restaurant?.reservationTo || 0);
  const [eventonly, setEventOnly] = useState(restaurant?.eventsonly || false);
  const [eventonlyOnline, setEventOnlyOnline] = useState(restaurant?.eventsOnlyOnline|| false);

  const [blockedDays, setBlockedDays] = useState(restaurant?.blocked_days || []);
  const [blockedDates, setBlockedDates] = useState(restaurant?.blocked_dates || []);
  const [newBlockedDate, setNewBlockedDate] = useState('');
  const [primaryColor, setPrimaryColor] = useState("#3fb488");
  const [secondaryColor, setSecondaryColor] = useState("#3fb488");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [acceptsOnline, setAcceptsOnline] = useState(false);
  const [cancellationPolicy, setCancellationPolicy] = useState(60);
  const [fontColor, setFontColor] = useState(restaurant?.fontColor || "#000000");
  const [minimumAge, setMinimumAge] = useState(restaurant?.minimum_age || 0);
  const [floorPlanWidth, setFloorPlanWidth] = useState(restaurant?.floorPlanWidth || 800);
  const [floorPlanHeight, setFloorPlanHeight] = useState(restaurant?.floorPlanHeight || 600);
  const [eventDates, setEventDates] = useState(restaurant?.event_dates || []);
  const [newEventDate, setNewEventDate] = useState('');
  const [noShowPolicy, setNoShowPolicy] = useState(restaurant?.noShowPolicy || 3);
  // New state for location availability
  const [lokaciiAvailability, setLokaciiAvailability] = useState(restaurant?.lokaciiAvailability || {});
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [newRuleDate, setNewRuleDate] = useState('');
  const [newRuleDayIndex, setNewRuleDayIndex] = useState(null);
  const [newRuleFrom, setNewRuleFrom] = useState(0);
  const [newRuleTo, setNewRuleTo] = useState(0);
  const [newRuleIsRecurring, setNewRuleIsRecurring] = useState(false);

  const [workingHours, setWorkingHours] = useState(
    restaurant?.working_hours || {
      0: { from: 10, to: 22 },
      1: { from: 10, to: 22 },
      2: { from: 10, to: 22 },
      3: { from: 10, to: 22 },
      4: { from: 10, to: 22 },
      5: { from: 10, to: 22 },
      6: { from: 10, to: 22 },
    }
  );

  useEffect(() => {
    if (restaurant) {
      setImages(restaurant.images || []);
      setPreviewImages(restaurant.images || []);
      setDiscount(restaurant.discount || 0);
      setTitle(restaurant.name || '');
      setLocation(restaurant.location || '');
      setDetails(restaurant.details || '');
      setMainImage(restaurant.mainImage || '');
      setMainImagePreview(restaurant.mainImage || '');
      setLink(restaurant.mapslink || '');
      setMaxGuests(restaurant.maximumGuests || 0);
      setLokacii(restaurant.lokacii || []);
      setLokaciiAvailability(restaurant.lokaciiavailability || {});
      setPlanSections(restaurant.planSections || []);
      setMenu(restaurant.menuUrl || '');
      setCategory2(restaurant.category2 || '');
      setReservationFrom(restaurant.reservationFrom || 0);
      setReservationTo(restaurant.reservationTo || 0);
      setEventOnly(restaurant.eventsonly || false);
      setEventOnlyOnline(restaurant.eventsOnlyOnline||false)
      setBlockedDays(restaurant.blocked_days || []);
      setBlockedDates(restaurant.blocked_dates || []);
      setMinimumAge(restaurant.minimum_age || 0);
      setSecondaryColor(restaurant.secondaryColor || "#3fb488");
      setPrimaryColor(restaurant.mainColor || "#3fb488");
      setIsDarkMode(restaurant.isDarkMode || false);
      setcontactInfo(restaurant.contactInfo || "");
      setAcceptsOnline(restaurant.acceptsOnline || false);
      setCancellationPolicy(restaurant.cancellationPolicy || 60);
      setFloorPlanWidth(restaurant.width || 800);
      setFloorPlanHeight(restaurant.height || 600);
      setFontColor(restaurant.fontColor || "#000000");
      setEventDates(restaurant.event_dates || []);
      setNoShowPolicy(restaurant.noShowPolicy || 3);
      setWorkingHours(
        restaurant.working_hours || {
          0: { from: 10, to: 22 },
          1: { from: 10, to: 22 },
          2: { from: 10, to: 22 },
          3: { from: 10, to: 22 },
          4: { from: 10, to: 22 },
          5: { from: 10, to: 22 },
          6: { from: 10, to: 22 },
        }
      );
    }
  }, [restaurant]);

  const revokePreviewUrl = (url) => {
    if (url && url.startsWith('blob:')) {
      URL.revokeObjectURL(url);
    }
  };

  const uploadSingleImage = async (file) => {
    const filePath = `${randomUUID()}.png`;
    const contentType = 'image/png';

    const { error } = await supabaseFreeTable.storage
      .from('restoranisliki')
      .upload(filePath, file, { contentType });

    if (error) {
      throw new Error(isMKD ? 'Грешка при качувањето на сликата' : 'Image upload failed');
    }

    const { data: { publicUrl } } = await supabaseFreeTable.storage
      .from('restoranisliki')
      .getPublicUrl(filePath);

    return publicUrl;
  };

  const pickAndUploadImages = async () => {
    try {
      let newMainImage = mainImage;
      const newImages = [...images];

      if (pendingMainImage) {
        newMainImage = await uploadSingleImage(pendingMainImage);
        revokePreviewUrl(mainImagePreview);
      }

      for (const file of pendingImages) {
        const imageUrl = await uploadSingleImage(file);
        newImages.push(imageUrl);
      }

      previewImages.forEach((url, index) => {
        if (index >= images.length) {
          revokePreviewUrl(url);
        }
      });

      return { newMainImage, newImages };
    } catch (err) {
      throw err;
    }
  };

  const confirmDeleteMainImage = () => {
    setLoading(true);
    setErrors('');

    if (mainImage && !mainImage.startsWith('blob:')) {
      const locationOfImage = mainImage.split('/restoranisliki/')[1];
      
      deleteImageFromBucket(
        { imageLocation: locationOfImage },
        {
          onSuccess: () => {
            deleteMainImageDatabase(
              { id: profile.restaurantid, mainImage: '' },
              {
                onSuccess: () => {
                  setMainImage('');
                  setMainImagePreview('');
                  setPendingMainImage(null);
                  setLoading(false);
                },
                onError: (error) => {
                  setErrors(isMKD ? 'Грешка при ажурирање на базата' : 'Error updating database');
                  setLoading(false);
                }
              }
            );
          },
          onError: (error) => {
            setErrors(isMKD ? 'Грешка при бришење на сликата' : 'Error deleting image');
            setLoading(false);
          }
        }
      );
    } else {
      revokePreviewUrl(mainImagePreview);
      setMainImage('');
      setMainImagePreview('');
      setPendingMainImage(null);
      setLoading(false);
    }
  };

  const confirmDeleteImage = (index) => {
    setLoading(true);
    setErrors('');

    if (index < images.length) {
      const imageToDelete = images[index];
      const locationOfImage = imageToDelete.split('/restoranisliki/')[1];
      const newImages = images.filter((_, i) => i !== index);
      const newPreviewImages = previewImages.filter((_, i) => i !== index);

      deleteImageFromBucket(
        { imageLocation: locationOfImage },
        {
          onSuccess: () => {
            updateDatabase(
              {
                id: restaurant.id,
                data: { images: newImages }
              },
              {
                onSuccess: () => {
                  setImages(newImages);
                  setPreviewImages(newPreviewImages);
                  setLoading(false);
                },
                onError: (error) => {
                  setErrors(isMKD ? 'Грешка при ажурирање на базата' : 'Error updating database');
                  setLoading(false);
                }
              }
            );
          },
          onError: (error) => {
            setErrors(isMKD ? 'Грешка при бришење на сликата' : 'Error deleting image');
            setLoading(false);
          }
        }
      );
    } else {
      const pendingIndex = index - images.length;
      const newPendingImages = pendingImages.filter((_, i) => i !== pendingIndex);
      const newPreviewImages = previewImages.filter((_, i) => i !== index);
      revokePreviewUrl(previewImages[index]);
      setPendingImages(newPendingImages);
      setPreviewImages(newPreviewImages);
      setLoading(false);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setPendingImages([...pendingImages, file]);
      const previewUrl = URL.createObjectURL(file);
      setPreviewImages([...previewImages, previewUrl]);
    }
  };

  const handleMainImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setPendingMainImage(file);
      if (mainImagePreview) {
        revokePreviewUrl(mainImagePreview);
      }
      const previewUrl = URL.createObjectURL(file);
      setMainImagePreview(previewUrl);
    }
  };

  const convertDDMMYYYYtoYYYYMMDD = (ddmmyyyy) => {
    const parts = ddmmyyyy.split('-');
    if (parts.length !== 3) return null;
    const [day, month, year] = parts.map(Number);
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime()) || date.getDate() !== day || date.getMonth() + 1 !== month || date.getFullYear() !== year) {
      return null;
    }
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  };

  const convertYYYYMMDDtoDDMMYYYY = (yyyymmdd) => {
    const parts = yyyymmdd.split('-');
    if (parts.length !== 3) return yyyymmdd;
    const [year, month, day] = parts;
    return `${day}-${month}-${year}`;
  };

  const toggleBlockedDay = (dayIndex) => {
    if (blockedDays.includes(dayIndex)) {
      setBlockedDays(blockedDays.filter((day) => day !== dayIndex));
    } else {
      setBlockedDays([...blockedDays, dayIndex].sort((a, b) => a - b));
    }
  };

  const daysOfWeek = [
    { index: 1, nameMK: 'Понеделник', nameEN: 'Monday' },
    { index: 2, nameMK: 'Вторник', nameEN: 'Tuesday' },
    { index: 3, nameMK: 'Среда', nameEN: 'Wednesday' },
    { index: 4, nameMK: 'Четврток', nameEN: 'Thursday' },
    { index: 5, nameMK: 'Петок', nameEN: 'Friday' },
    { index: 6, nameMK: 'Сабота', nameEN: 'Saturday' },
    { index: 0, nameMK: 'Недела', nameEN: 'Sunday' },
  ];

  const updateWorkingHours = (dayIndex, field, value) => {
    setWorkingHours((prev) => ({
      ...prev,
      [dayIndex]: {
        ...prev[dayIndex],
        [field]: parseInt(value),
      },
    }));
  };

  const copyTimeToAllDays = (dayIndex) => {
    const sourceDay = workingHours[dayIndex];
    const newWorkingHours = {};
    for (let i = 0; i <= 6; i++) {
      newWorkingHours[i] = { ...sourceDay };
    }
    setWorkingHours(newWorkingHours);
  };

  const addBlockedDate = () => {
    if (!newBlockedDate) {
      setErrors(isMKD ? 'Внесете датум' : 'Enter a date');
      return;
    }
    const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
    if (!dateRegex.test(newBlockedDate)) {
      setErrors(isMKD ? 'Невалиден формат на датум (DD-MM-YYYY)' : 'Invalid date format (DD-MM-YYYY)');
      return;
    }
    const yyyymmdd = convertDDMMYYYYtoYYYYMMDD(newBlockedDate);
    if (!yyyymmdd) {
      setErrors(isMKD ? 'Невалиден датум' : 'Invalid date');
      return;
    }
    const date = new Date(yyyymmdd);
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    if (date < now) {
      setErrors(isMKD ? 'Датумот мора да биде во иднина' : 'Date must be in the future');
      return;
    }
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);
    if (date > maxDate) {
      setErrors(isMKD ? 'Датумот мора да биде во следните 3 месеци' : 'Date must be within the next 3 months');
      return;
    }
    if (blockedDates.includes(yyyymmdd)) {
      setErrors(isMKD ? 'Овој датум е веќе блокиран' : 'This date is already blocked');
      return;
    }
    setBlockedDates([...blockedDates, yyyymmdd].sort());
    setNewBlockedDate('');
    setErrors('');
  };

  const addEventDate = () => {
    if (!newEventDate) {
      setErrors(isMKD ? 'Внесете датум за настан' : 'Enter an event date');
      return;
    }
    const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
    if (!dateRegex.test(newEventDate)) {
      setErrors(isMKD ? 'Невалиден формат на датум (DD-MM-YYYY)' : 'Invalid date format (DD-MM-YYYY)');
      return;
    }
    const yyyymmdd = convertDDMMYYYYtoYYYYMMDD(newEventDate);
    if (!yyyymmdd) {
      setErrors(isMKD ? 'Невалиден датум' : 'Invalid date');
      return;
    }
    const date = new Date(yyyymmdd);
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    if (date < now) {
      setErrors(isMKD ? 'Датумот за настан мора да биде во иднина' : 'Event date must be in the future');
      return;
    }
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);
    if (date > maxDate) {
      setErrors(isMKD ? 'Датумот за настан мора да биде во следните 3 месеци' : 'Event date must be within the next 3 months');
      return;
    }
    if (eventDates.includes(yyyymmdd)) {
      setErrors(isMKD ? 'Овој датум за настан е веќе додаден' : 'This event date is already added');
      return;
    }
    setEventDates([...eventDates, yyyymmdd].sort());
    setNewEventDate('');
    setErrors('');
  };

  const removeEventDate = (date) => {
    setEventDates(eventDates.filter((d) => d !== date));
  };

  const addSeatingLocation = () => {
    if (sedenje.trim()) {
      setLokacii([sedenje, ...lokacii]);
      setLokaciiAvailability((prev) => ({
        ...prev,
        [sedenje]: []
      }));
      setSedenje('');
    }
  };

  const removeSeatingLocation = (location) => {
    setLokacii(lokacii.filter((l) => l !== location));
    setLokaciiAvailability((prev) => {
      const newAvailability = { ...prev };
      delete newAvailability[location];
      return newAvailability;
    });
  };

  const addPlanSection = () => {
    if (newPlanSection.trim()) {
      setPlanSections([newPlanSection, ...planSections]);
      setNewPlanSection('');
    }
  };

  const removePlanSection = (section) => {
    setPlanSections(planSections.filter((s) => s !== section));
  };

  const addDisabledRule = (locationName) => {
    if (!newRuleIsRecurring && !newRuleDate) {
      setErrors(isMKD ? 'Внесете датум за правило' : 'Enter a date for the rule');
      return;
    }
    if (newRuleIsRecurring && newRuleDayIndex === null) {
      setErrors(isMKD ? 'Изберете ден за правило' : 'Select a day for recurring rule');
      return;
    }
    if (newRuleFrom < 0 || newRuleFrom > 23 || newRuleTo < 1 || newRuleTo > 24 || newRuleFrom >= newRuleTo) {
      setErrors(isMKD ? 'Невалиден опсег на време' : 'Invalid time range');
      return;
    }
    if (!newRuleIsRecurring) {
      const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
      if (!dateRegex.test(newRuleDate)) {
        setErrors(isMKD ? 'Невалиден формат на датум (DD-MM-YYYY)' : 'Invalid date format (DD-MM-YYYY)');
        return;
      }
      const yyyymmdd = convertDDMMYYYYtoYYYYMMDD(newRuleDate);
      if (!yyyymmdd) {
        setErrors(isMKD ? 'Невалиден датум' : 'Invalid date');
        return;
      }
      const date = new Date(yyyymmdd);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      if (date < now) {
        setErrors(isMKD ? 'Датумот мора да биде во иднина' : 'Date must be in the future');
        return;
      }
      const maxDate = new Date();
      maxDate.setMonth(maxDate.getMonth() + 3);
      if (date > maxDate) {
        setErrors(isMKD ? 'Датумот мора да биде во следните 3 месеци' : 'Date must be within the next 3 months');
        return;
      }
    }
    setLokaciiAvailability((prev) => ({
      ...prev,
      [locationName]: [
        ...(prev[locationName] || []),
        {
          date: newRuleIsRecurring ? null : convertDDMMYYYYtoYYYYMMDD(newRuleDate),
          dayIndex: newRuleIsRecurring ? newRuleDayIndex : null,
          from: parseInt(newRuleFrom),
          to: parseInt(newRuleTo)
        }
      ]
    }));
    setNewRuleDate('');
    setNewRuleDayIndex(null);
    setNewRuleFrom(0);
    setNewRuleTo(0);
    setNewRuleIsRecurring(false);
    setSelectedLocation(null);
    setErrors('');
  };

  const removeDisabledRule = (locationName, ruleIndex) => {
    setLokaciiAvailability((prev) => ({
      ...prev,
      [locationName]: prev[locationName].filter((_, index) => index !== ruleIndex)
    }));
  };

  const removeBlockedDate = (date) => {
    setBlockedDates(blockedDates.filter((d) => d !== date));
  };

  const updateRestaurant = async () => {
    setLoading(true);
    setErrors('');

    // Validate workingHours
    for (let day = 0; day <= 6; day++) {
      if (!workingHours[day] || typeof workingHours[day].from !== 'number' || typeof workingHours[day].to !== 'number') {
        setErrors(isMKD ? 'Невалидни работни часови' : 'Invalid working hours');
        setLoading(false);
        return;
      }
      if (workingHours[day].from < 0 || workingHours[day].from > 23 || workingHours[day].to < 1 || workingHours[day].to > 24 || workingHours[day].from >= workingHours[day].to) {
        setErrors(isMKD ? 'Невалиден опсег на работни часови' : 'Invalid working hours range');
        setLoading(false);
        return;
      }
    }

    // Validate blockedDays
    if (!Array.isArray(blockedDays) || blockedDays.some((day) => !Number.isInteger(day) || day < 0 || day > 6)) {
      setErrors(isMKD ? 'Невалидни блокирани денови' : 'Invalid blocked days');
      setLoading(false);
      return;
    }

    // Validate minimumAge
    if (minimumAge < 0) {
      setErrors(isMKD ? 'Минималната возраст мора да биде 0 или поголема' : 'Minimum age must be 0 or greater');
      setLoading(false);
      return;
    }

    // Validate noShowPolicy
    if (noShowPolicy < 0) {
      setErrors(isMKD ? 'Бројот на дозволени неостварени резервации мора да биде 0 или поголем' : 'Number of allowed no-shows must be 0 or greater');
      setLoading(false);
      return;
    }

    try {
      const { newMainImage, newImages } = await pickAndUploadImages();

      setMainImage(newMainImage);
      setMainImagePreview(newMainImage);
      setImages(newImages);
      setPreviewImages(newImages);
      setPendingImages([]);
      setPendingMainImage(null);

      updateDatabase(
        {
          id: restaurant.id,
          data: {
            name: title,
            details: details,
            maximumGuests: maxGuests,
            lokacii: lokacii,
            lokaciiAvailability: lokaciiAvailability,
            planSections: planSections,
            location: location,
            mapslink: link,
            menuUrl: menu,
            category2: category2,
            reservationFrom: reservationFrom,
            reservationTo: reservationTo,
            discount: discount,
            eventonly: eventonly,
            eventsOnlyOnline:eventonlyOnline,
            blocked_dates: blockedDates,
            blocked_days: blockedDays,
            mainImage: newMainImage,
            images: newImages,
            isDarkMode: isDarkMode,
            mainColor: primaryColor,
            secondaryColor: secondaryColor,
            contactInfo: contactInfo,
            acceptsOnline: acceptsOnline,
            workingHours: workingHours,
            cancellationPolicy: cancellationPolicy,
            height: floorPlanHeight,
            width: floorPlanWidth,
            fontColor: fontColor,
            minimum_age: minimumAge,
            eventsonly: eventonly,
            event_dates: eventonlyOnline? eventDates : [],
            noShowPolicy: noShowPolicy,
          },
        },
        {
          onSuccess: () => {
            setLoading(false);
          },
          onError: (error) => {
            setErrors(isMKD ? 'Грешка при ажурирање на податоците' : 'Error updating data');
            setLoading(false);
          },
        }
      );
    } catch (err) {
      setErrors(isMKD ? 'Грешка при качувањето на сликите' : 'Error uploading images');
      setLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-message">Грешка во вчитување</div>
      </div>
    );
  }

  return (
    <div className="main-container">
      <div className="header">
        <div className="header-content">
          <div className="header-title">
            <Settings className="header-icon" />
            <h1>{isMKD ? 'Поставки Test' : 'Settings'}</h1>
          </div>
        </div>
      </div>

      <div className="content-container">
        <div className="grid-container">
          <div className="section">
            <div className="card">
              <label className="section-label">
                <Camera className="icon" />
                {isMKD ? 'Главна слика' : 'Main Image'}
              </label>
              <div className="image-container">
                {mainImagePreview ? (
                  <div className="image-group">
                    <img 
                      src={mainImagePreview} 
                      alt="Main" 
                      className="main-image"
                    />
                    <button
                      onClick={confirmDeleteMainImage}
                      className="remove-image-button"
                    >
                      <X className="small-icon" />
                    </button>
                  </div>
                ) : (
                  <label className="upload-placeholder">
                    <Camera className="upload-icon" />
                    <span>{isMKD ? 'Додај главна слика' : 'Add main image'}</span>
                    <input type="file" className="hidden-input" accept="image/*" onChange={handleMainImageUpload} />
                  </label>
                )}
              </div>
            </div>

            <div className="card">
              <div className="images-header">
                <label className="section-label">
                  <Camera className="icon" />
                  {isMKD ? 'Слики' : 'Images'}
                </label>
                <label className="add-image-button">
                  <Plus className="icon" />
                  <input type="file" className="hidden-input" accept="image/*" onChange={handleImageUpload} />
                </label>
              </div>
              <div className="images-grid">
                {previewImages.map((image, index) => (
                  <div key={index} className="image-group">
                    <img 
                      src={image} 
                      alt={`Gallery ${index}`} 
                      className="gallery-image"
                    />
                    <button
                      onClick={() => confirmDeleteImage(index)}
                      className="remove-image-button"
                    >
                      <X className="tiny-icon" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="section">
            <div className="card">
              <h2 className="section-title">
                {isMKD ? 'Основни информации' : 'Basic Information'}
              </h2>
              <div className="form-group">
                <div>
                  <label className="form-label">
                    {isMKD ? 'Име' : 'Name'}
                  </label>
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="form-input"
                    placeholder={isMKD ? 'Име на ресторан' : 'Restaurant name'}
                  />
                </div>
                <div>
                  <label className="form-label">
                    <MapPin className="inline-icon" />
                    {isMKD ? 'Адреса' : 'Address'}
                  </label>
                  <input
                    type="text"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    className="form-input"
                    placeholder={isMKD ? 'Адреса' : 'Address'}
                  />
                </div>
                <div>
                  <label className="form-label">
                    <Percent className="inline-icon" />
                    {isMKD ? 'Попуст' : 'Discount'}
                  </label>
                  <div className="discount-group">
                    <input
                      type="number"
                      value={discount}
                      onChange={(e) => setDiscount(e.target.value)}
                      className="discount-input"
                      min="0"
                      max="100"
                    />
                    <span className="percent-symbol">%</span>
                  </div>
                </div>
                <div>
                  <label className="form-label">
                    <Link className="inline-icon" />
                    {isMKD ? 'Google Maps линк' : 'Google Maps Link'}
                  </label>
                  <input
                    type="url"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                    className="form-input"
                    placeholder="https://maps.google.com/..."
                  />
                </div>
                <div>
                  <label className="form-label">
                    <Users className="inline-icon" />
                    {isMKD ? 'Максимален број на гости' : 'Maximum Number of Guests'}
                  </label>
                  <input
                    type="number"
                    value={maxGuests}
                    onChange={(e) => setMaxGuests(e.target.value)}
                    className="form-input"
                    min="1"
                  />
                </div>
                <div>
                  <label className="form-label">
                    <Users className="inline-icon" />
                    {isMKD ? 'Минимална возраст' : 'Minimum Age'}
                  </label>
                  <input
                    type="number"
                    value={minimumAge}
                    onChange={(e) => setMinimumAge(Number(e.target.value))}
                    className="form-input"
                    min="0"
                    placeholder={isMKD ? 'Минимална возраст (0 за без ограничување)' : 'Minimum age (0 for no restriction)'}
                  />
                </div>
                <div>
                  <label className="form-label">
                    <Users className="inline-icon" />
                    {isMKD ? 'Дозволени неуспешни резервации' : 'Allowed No-Shows'}
                  </label>
                  <input
                    type="number"
                    value={noShowPolicy}
                    onChange={(e) => setNoShowPolicy(Number(e.target.value))}
                    className="form-input"
                    min="0"
                    placeholder={isMKD ? 'Број на дозволени неуспешни резервации' : 'Number of allowed no-shows'}
                  />
                </div>
                <div>
                  <label className="form-label">
                    <FileText className="inline-icon" />
                    {isMKD ? 'Повеќе информации' : 'More Information'}
                  </label>
                  <textarea
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                    rows="3"
                    className="form-textarea"
                    placeholder={isMKD ? 'Детали за ресторанот' : 'Restaurant details'}
                  />
                </div>
              </div>
            </div>
            <div className="card">
              <h2 className="section-title">
                {isMKD ? 'Димензии на план' : 'Floor Plan Dimensions'}
              </h2>
              <div className="form-group">
                <div>
                  <label className="form-label">
                    {isMKD ? 'Ширина (пиксели)' : 'Width (pixels)'}
                  </label>
                  <input
                    type="number"
                    value={floorPlanWidth}
                    onChange={(e) => setFloorPlanWidth(e.target.value)}
                    className="form-input"
                    min="400"
                    max="2000"
                    placeholder={isMKD ? 'Ширина' : 'Width'}
                  />
                </div>
                <div>
                  <label className="form-label">
                    {isMKD ? 'Висина (пиксели)' : 'Height (pixels)'}
                  </label>
                  <input
                    type="number"
                    value={floorPlanHeight}
                    onChange={(e) => setFloorPlanHeight(e.target.value)}
                    className="form-input"
                    min="300"
                    max="1500"
                    placeholder={isMKD ? 'Висина' : 'Height'}
                  />
                </div>
              </div>
            </div>

            <div className="card">
              <h2 className="section-title">
                {isMKD ? 'Места за седење' : 'Seating Locations'}
              </h2>
              <div className="seating-input-group">
                <input
                  type="text"
                  value={sedenje}
                  onChange={(e) => setSedenje(e.target.value)}
                  className="form-input"
                  placeholder={isMKD ? 'Место за седење' : 'Seating location'}
                />
                <button
                  onClick={addSeatingLocation}
                  className="add-button"
                >
                  <Plus className="small-icon" />
                </button>
              </div>
              <div className="seating-list">
                {lokacii.map((location, index) => (
                  <div key={index} className="seating-item">
                    <span>{location}</span>
                    <button
                      onClick={() => removeSeatingLocation(location)}
                      className="remove-button"
                    >
                      <X className="small-icon" />
                    </button>
                    <button
                      onClick={() => setSelectedLocation(location)}
                      className="add-button"
                      style={{ marginLeft: '8px' }}
                    >
                      {isMKD ? 'Правила' : 'Rules'}
                    </button>
                    {selectedLocation === location && (
                      <div className="rules-section" style={{ marginTop: '8px', padding: '8px', border: '1px solid #e5e7eb', borderRadius: '4px' }}>
                        <h3>{isMKD ? 'Правила за затварање' : 'Disable Rules'}</h3>
                        <div className="rule-input-group" style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                          <label className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={newRuleIsRecurring}
                              onChange={(e) => setNewRuleIsRecurring(e.target.checked)}
                              className="checkbox-input"
                            />
                            <span>{isMKD ? 'Неделно ниво' : 'Recurring'}</span>
                          </label>
                          {newRuleIsRecurring ? (
                            <select
                              value={newRuleDayIndex === null ? '' : newRuleDayIndex}
                              onChange={(e) => setNewRuleDayIndex(e.target.value === '' ? null : parseInt(e.target.value))}
                              className="form-input"
                            >
                              <option value="">{isMKD ? 'Избери ден' : 'Select day'}</option>
                              {daysOfWeek.map((day) => (
                                <option key={day.index} value={day.index}>
                                  {isMKD ? day.nameMK : day.nameEN}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type="text"
                              value={newRuleDate}
                              onChange={(e) => setNewRuleDate(e.target.value)}
                              className="form-input"
                              placeholder={isMKD ? 'Датум (DD-MM-YYYY)' : 'Date (DD-MM-YYYY)'}
                            />
                          )}
                          <input
                            type="number"
                            value={newRuleFrom}
                            onChange={(e) => setNewRuleFrom(e.target.value)}
                            className="time-input"
                            min="0"
                            max="23"
                            placeholder={isMKD ? 'Од' : 'From'}
                          />
                          <input
                            type="number"
                            value={newRuleTo}
                            onChange={(e) => setNewRuleTo(e.target.value)}
                            className="time-input"
                            min="1"
                            max="24"
                            placeholder={isMKD ? 'До' : 'To'}
                          />
                          <button
                            onClick={() => addDisabledRule(location)}
                            className="add-button"
                          >
                            <Plus className="small-icon" />
                          </button>
                        </div>
                        <div className="rules-list">
                          {(lokaciiAvailability[location] || []).map((rule, ruleIndex) => (
                            <div key={ruleIndex} className="rule-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                              <span>
                                {rule.date
                                  ? convertYYYYMMDDtoDDMMYYYY(rule.date)
                                  : (isMKD ? daysOfWeek.find(d => d.index === rule.dayIndex)?.nameMK : daysOfWeek.find(d => d.index === rule.dayIndex)?.nameEN)}
                                {` (${rule.from}:00 - ${rule.to}:00)`}
                              </span>
                              <button
                                onClick={() => removeDisabledRule(location, ruleIndex)}
                                className="remove-button"
                              >
                                <X className="small-icon" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="card">
              <h2 className="section-title">
                {isMKD ? 'Секции на план' : 'Plan Sections'}
              </h2>
              <div className="seating-input-group">
                <input
                  type="text"
                  value={newPlanSection}
                  onChange={(e) => setNewPlanSection(e.target.value)}
                  className="form-input"
                  placeholder={isMKD ? 'Секција на план' : 'Plan section'}
                />
                <button
                  onClick={addPlanSection}
                  className="add-button"
                >
                  <Plus className="small-icon" />
                </button>
              </div>
              <div className="seating-list">
                {planSections.map((section, index) => (
                  <div key={index} className="seating-item">
                    <span>{section}</span>
                    <button
                      onClick={() => removePlanSection(section)}
                      className="remove-button"
                    >
                      <X className="small-icon" />
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="card">
              <h2 className="section-title">
                <Clock className="icon" />
                {isMKD ? 'Работни часови' : 'Working Hours'}
              </h2>
              {daysOfWeek.map((day) => (
                <div key={day.index} className="working-hours-row">
                  <div className="day-name">
                    {isMKD ? day.nameMK : day.nameEN}
                  </div>
                  {blockedDays.includes(day.index) ? (
                    <div className="closed-label">
                      {isMKD ? 'Затворено' : 'Closed'}
                    </div>
                  ) : (
                    <div className="time-inputs">
                      <div className="time-input-group">
                        <label>{isMKD ? 'Од' : 'From'}</label>
                        <input
                          type="number"
                          value={workingHours[day.index]?.from || 10}
                          onChange={(e) => updateWorkingHours(day.index, 'from', e.target.value)}
                          className="time-input"
                          min="0"
                          max="23"
                        />
                        <span>:00</span>
                      </div>
                      <div className="time-input-group">
                        <label>{isMKD ? 'До' : 'To'}</label>
                        <input
                          type="number"
                          value={workingHours[day.index]?.to || 22}
                          onChange={(e) => updateWorkingHours(day.index, 'to', e.target.value)}
                          className="time-input"
                          min="1"
                          max="24"
                        />
                        <span>:00</span>
                      </div>
                      <button
                        type="button"
                        onClick={() => copyTimeToAllDays(day.index)}
                        className="copy-time-button"
                        title={isMKD ? 'Копирај на сите денови' : 'Copy to all days'}
                      >
                        <Plus className="small-icon" />
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>



            <div className="card">
              <h2 className="section-title">
                <IoColorPaletteOutline className="icon" />
                {isMKD ? 'Бои и тема' : 'Colors and Theme'}
              </h2>
              <div className="form-group">
                <div>
                  <label className="form-label">
                    {isMKD ? 'Примарна боја' : 'Primary Color'}
                  </label>
                  <input
                    type="color"
                    value={primaryColor}
                    onChange={(e) => setPrimaryColor(e.target.value)}
                    className="color-input"
                  />
                </div>
                <div>
                  <label className="form-label">
                    {isMKD ? 'Секундарна боја' : 'Secondary Color'}
                  </label>
                  <input
                    type="color"
                    value={secondaryColor}
                    onChange={(e) => setSecondaryColor(e.target.value)}
                    className="color-input"
                  />
                </div>
                <div>
                  <label className="form-label">
                    {isMKD ? 'Боја на фонт' : 'Font Color'}
                  </label>
                  <input
                    type="color"
                    value={fontColor}
                    onChange={(e) => setFontColor(e.target.value)}
                    className="color-input"
                  />
                </div>
              </div>
              <label className="form-label">
                {isDarkMode ? <Moon className="inline-icon" /> : <Sun className="inline-icon" />}
                {isMKD ? 'Режим на приказ' : 'Display Mode'}
              </label>
              <div
                style={{
                  display: 'flex',
                  backgroundColor: '#f9fafb',
                  borderRadius: '8px',
                  padding: '4px',
                  gap: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                }}
              >
                <button
                  type="button"
                  onClick={() => setIsDarkMode(false)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    border: 'none',
                    backgroundColor: !isDarkMode ? '#ffffff' : 'transparent',
                    color: !isDarkMode ? '#111827' : '#6b7280',
                    fontWeight: !isDarkMode ? '500' : '400',
                    fontSize: '0.875rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: !isDarkMode ? '0 1px 2px rgba(0, 0, 0, 0.05)' : 'none',
                    outline: 'none'
                  }}
                  onMouseEnter={(e) => {
                    if (!isDarkMode) {
                      e.target.style.backgroundColor = '#f3f4f6';
                    } else {
                      e.target.style.backgroundColor = '#f9fafb';
                      e.target.style.color = '#374151';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isDarkMode) {
                      e.target.style.backgroundColor = '#ffffff';
                    } else {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#6b7280';
                    }
                  }}
                >
                  <Sun
                    size={16}
                    style={{
                      transition: 'all 0.2s ease',
                      color: !isDarkMode ? '#f59e0b' : 'rgba(0, 0, 0, 0.4)'
                    }}
                  />
                  {isMKD ? 'Светло' : 'Light'}
                </button>
                <button
                  type="button"
                  onClick={() => setIsDarkMode(true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    border: 'none',
                    backgroundColor: isDarkMode ? '#111827' : 'transparent',
                    color: isDarkMode ? '#ffffff' : '#6b7280',
                    fontWeight: isDarkMode ? '500' : '400',
                    fontSize: '0.875rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: isDarkMode ? '0 1px 2px rgba(0, 0, 0, 0.05)' : 'none',
                    outline: 'none'
                  }}
                  onMouseEnter={(e) => {
                    if (isDarkMode) {
                      e.target.style.backgroundColor = '#1f2937';
                    } else {
                      e.target.style.backgroundColor = '#f9fafb';
                      e.target.style.color = '#374151';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (isDarkMode) {
                      e.target.style.backgroundColor = '#111827';
                    } else {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#6b7280';
                    }
                  }}
                >
                  <Moon
                    size={16}
                    style={{
                      transition: 'all 0.2s ease',
                      color: isDarkMode ? '#3b82f6' : 'rgba(0, 0, 0, 0.4)'
                    }}
                  />
                  {isMKD ? 'Темно' : 'Dark'}
                </button>
              </div>
            </div>

            <div className="card">
              <label className="form-label">
                {isMKD ? 'Мени' : 'Menu'}
              </label>
              <input
                type="url"
                value={menu}
                onChange={(e) => setMenu(e.target.value)}
                className="form-input"
                placeholder={isMKD ? 'Линк до мени' : 'Menu link'}
              />
            </div>
            <div className="card">
              <label className="form-label">
                {isMKD ? 'Политика за откажување и ажурирање (минути)' : 'Update and cancellation policy'}
              </label>
              <input
                type="url"
                value={cancellationPolicy}
                onChange={(e) => setCancellationPolicy(e.target.value)}
                className="form-input"
                placeholder={isMKD ? 'Минути пред откажување' : 'Minutes before cancellation'}
              />
            </div>

            <div className="card">
              <label className="form-label">
                {isMKD ? 'Информации за контакт' : 'Contact Info'}
              </label>
              <input
                type="url"
                value={contactInfo}
                onChange={(e) => setcontactInfo(e.target.value)}
                className="form-input"
                placeholder={isMKD ? 'Информации за контакт' : 'Contact Info'}
              />
            </div>
            <div className="card">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={eventonlyOnline}
                  onChange={(e) => setEventOnlyOnline(e.target.checked)}
                  className="checkbox-input"
                />
                <span className="checkbox-text">
                  {isMKD ? 'Резервации само за настани (веб)' : 'Reservations Only for Events'}
                </span>
              </label>
            </div>

            <div className="card">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={eventonly}
                  onChange={(e) => setEventOnly(e.target.checked)}
                  className="checkbox-input"
                />
                <span className="checkbox-text">
                  {eventonlyOnline? 'Синхронизирај календар за настани со апликација' : 'Резервации само за настани (апликација)'}
                </span>
              </label>
            </div>


            

            <div className="card">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={acceptsOnline}
                  onChange={(e) => setAcceptsOnline(e.target.checked)}
                  className="checkbox-input"
                />
                <span className="checkbox-text">
                  {isMKD ? 'Онлајн резервации' : 'Online reservations'}
                </span>
              </label>
            </div>
          </div>
        </div>

        <div className="grid-container">
          <div className="card">
            <h2 className="section-title">
              <Calendar className="icon" />
              {isMKD ? 'Неработни денови' : 'Non-Working Days'}
            </h2>
            <div className="days-grid">
              {daysOfWeek.map((day) => (
                <label key={day.index} className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={blockedDays.includes(day.index)}
                    onChange={() => toggleBlockedDay(day.index)}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">
                    {isMKD ? day.nameMK : day.nameEN}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="card">
            <h2 className="section-title">
              {isMKD ? 'Неработни датуми' : 'Blocked Dates'}
            </h2>
            <div className="blocked-dates-input-group">
              <input
                type="text"
                value={newBlockedDate}
                onChange={(e) => setNewBlockedDate(e.target.value)}
                className="form-input"
                placeholder={isMKD ? 'Датум (DD-MM-YYYY)' : 'Date (DD-MM-YYYY)'}
              />
              <button
                onClick={addBlockedDate}
                className="add-button"
              >
                <Plus className="small-icon" />
              </button>
            </div>
            <div className="blocked-dates-list">
              {blockedDates.map((date, index) => (
                <div key={index} className="blocked-date-item">
                  <span>{convertYYYYMMDDtoDDMMYYYY(date)}</span>
                  <button
                    onClick={() => removeBlockedDate(date)}
                    className="remove-button"
                  >
                    <X className="small-icon" />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {eventonlyOnline && (
            <div className="card">
              <h2 className="section-title">
                <Calendar className="icon" />
                {isMKD ? 'Датуми за настани' : 'Event Dates'}
              </h2>
              <div className="blocked-dates-input-group">
                <input
                  type="text"
                  value={newEventDate}
                  onChange={(e) => setNewEventDate(e.target.value)}
                  className="form-input"
                  placeholder={isMKD ? 'Датум за настан (DD-MM-YYYY)' : 'Event date (DD-MM-YYYY)'}
                />
                <button
                  onClick={addEventDate}
                  className="add-button"
                >
                  <Plus className="small-icon" />
                </button>
              </div>
              <div className="blocked-dates-list">
                {eventDates.map((date, index) => (
                  <div key={index} className="blocked-date-item">
                    <span>{convertYYYYMMDDtoDDMMYYYY(date)}</span>
                    <button
                      onClick={() => removeEventDate(date)}
                      className="remove-button"
                    >
                      <X className="small-icon" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {errors && (
          <div className="error-box">
            <div className="error-message">{errors}</div>
          </div>
        )}

        <div className="save-button-container">
          <button
            onClick={updateRestaurant}
            disabled={loading}
            className="save-button"
          >
            {loading ? (
              <div className="spinner"></div>
            ) : (
              <Check className="icon" />
            )}
            {isMKD ? 'ЗАЧУВАЈ' : 'SAVE'}
          </button>
        </div>
      </div>
    </div>
  );
}
